module.exports = __webpack_public_path__ + "index_pc/media/exp_tip_02.8e6fd5e9.aac";